import { useEffect } from 'react'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useScript } from '@bluheadless/ui-logic/src/hooks/use-script/useScript'
import { useCountryShippingDefault } from '@bluheadless/ui-logic/src/hooks/useCountryShippingDefault'
import { string, number } from 'prop-types'
import { Root } from './placement.styled'

const Placement = ({ purchaseAmount, placementKey, ...props }) => {
	const {
		locale,
		sales: {
			payments: {
				klarna: { enabled, clientId, placementScriptUrl },
			},
		},
	} = useConfig()

	const status = useScript({
		src: enabled ? placementScriptUrl : null,
		attributes: { 'data-client-id': clientId },
	})

	const { country: defaultShippingCountry } = useCountryShippingDefault()

	useEffect(() => {
		if (status === 'ready') {
			if (window.Klarna?.OnsiteMessaging?.loaded) {
				window.Klarna?.OnsiteMessaging?.refresh?.()
			}
		}
	}, [placementKey, purchaseAmount, status])

	return status === 'ready' && defaultShippingCountry?.code ? (
		<Root className="KlarnaPlacement-root" {...props}>
			<klarna-placement
				data-key={placementKey}
				data-locale={locale.split('-')[0] + '-' + defaultShippingCountry.code}
				data-purchase-amount={purchaseAmount ? Math.round(purchaseAmount * 100) : null}
			/>
		</Root>
	) : null
}

Placement.propTypes = {
	placementKey: string.isRequired,
	purchaseAmount: number,
}

export default Placement
